
import Product, { WeightedProductUnitMeasure } from "@/models/Product";
import Vue from "vue";
import increaseQtyBtn from "@/components/Cart/CartActions/IncreaseItemCart.vue"
import decreaseQtyBtn from "@/components/Cart/CartActions/DecreaseItemCart.vue"
import WsaButton from "@/components/UI/Button/UIButton.vue";
import UIMoneyFormat from "@/components/UI/Money/UIMoneyFormat.vue";

export default Vue.extend({

    props: {
        parentItem: {
            type: Product,
            required: false,
            default: null
        },

        item: {
            type: Product,
            required: true
        },

        currentSelectedReplacement: {
            type: Product,
            required: false
        },

        itemStatus: {
            type: Number,
            required: false
        },

        isSelectedAsReplacement: {
            type: Boolean,
            required: false,
            default: false
        },

        replacementsObject: {
            type: Array,
            required: false
        },

        isFromDialog: {
            type: Boolean,
            required: false
        },
    },

    components: {
        "increase-btn": increaseQtyBtn,
        "decrease-btn": decreaseQtyBtn,
        "wsa-button": WsaButton,
        "money-format": UIMoneyFormat,
    },

    data: () => ({
        selectedReplacementQuantity: 0 as number,
    }),

    methods: {
        selectItemReplacement(item: Product) {
            this.selectedReplacementQuantity = 1;
            this.$emit("onClick", item);
        },

        setItemAlternative() {
            this.$emit("onReplacementSubmission", {
                replacementItem: this.item,
                quantity: this.selectedReplacementQuantity
            })
        },

        increaseQuantity() {
            if(this.currentSelectedReplacement.id == this.parentItem?.id) 
            {
                if(this.selectedReplacementQuantity < this.parentItem.actualQtyOnHand)
                    this.selectedReplacementQuantity++;
            }

            else if(this.selectedReplacementQuantity < this.item.maxOrder)
                this.selectedReplacementQuantity++;

            this.$emit("replacementQuantityChanged", this.selectedReplacementQuantity)
        },

        decreaseQuantity() {
            if(this.selectedReplacementQuantity > 1) {
                this.selectedReplacementQuantity--;
                this.$emit("replacementQuantityChanged", this.selectedReplacementQuantity)
            }
            else
                this.$emit("removeSelectedReplacement")
        },

        getReplacementSelectedQty() {   
            if(this.parentItem?.actualQtyOnHand) {
                if(this.currentSelectedReplacement.id == this.parentItem.id)
                    this.selectedReplacementQuantity = this.parentItem.actualQtyOnHand;
                else
                    this.selectedReplacementQuantity = this.parentItem?.purchasedQuantity ?? 0;
            }

            else {
                this.selectedReplacementQuantity = this.parentItem?.purchasedQuantity ?? 0;
            }

            if(typeof this.replacementsObject != "undefined" && this.replacementsObject != null && this.replacementsObject.length > 0) {
                var replacementFound = this.replacementsObject.find((x: any) => x.oosItem.id == this.item.id);
                
                if(replacementFound != null) {
                    this.selectedReplacementQuantity = (replacementFound as any).quantity;
                }
            }

            this.$emit("replacementQuantityChanged", this.selectedReplacementQuantity)
        },

        replacementQuantity (): number {
            if(typeof this.replacementsObject != "undefined" && this.replacementsObject != null)
            var found = this.replacementsObject.find((x: any) => x.replacementItem && x.replacementItem.id == this.item.id);

            if(found != null) {
                return (found as any).quantity
            }

            return 0
        }
    },

    watch: {
        "item.id" () {
            this.getReplacementSelectedQty();
        },

        "currentSelectedReplacement.id"() {
            this.getReplacementSelectedQty();
        },

        
    },


    mounted() {
        this.getReplacementSelectedQty();
    }

})

